import React, { useState } from "react";
import { Box, Stack, Button, Typography } from "@mui/material";
import MyDatePicker from "../../atoms/Common/MyDatePicker";
import LGModal from "../../molecules/LGModal";
import { scheduleFromReceipts } from "../../api/scheduledPayments";
import { handleError } from "../../services/errorHandler";
import { useSnack } from "../../services/SnakbarProvider";

export default function SchedulePaymentsFromReceiptsModal({ open, handleClose, companyId, onScheduled }) {
  const [paymentDate, setPaymentDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const { openSnack } = useSnack();

  const handleSubmit = async () => {
    if (!paymentDate || loading) return;

    try {
      setLoading(true);
      const response = await scheduleFromReceipts({
        companyId,
        paymentDate: paymentDate.format("YYYY-MM-DD"),
      });

      const { scheduledPaymentsCreated, fullyScheduledReceipts, partiallyScheduledReceipts } = response.data;

      if (!scheduledPaymentsCreated) {
        openSnack("No hay contrarrecibos con pagos pendientes en esa fecha", "warning");
      } else {
        openSnack(
          `${scheduledPaymentsCreated} corrida(s) de pago creada(s) — ${fullyScheduledReceipts} contrarrecibo(s) programado(s), ${partiallyScheduledReceipts} parcial(es)`,
          "success"
        );
      }

      setPaymentDate(null);
      handleClose();
      if (onScheduled) onScheduled();
    } catch (error) {
      openSnack(handleError(error) || "Error al programar los pagos", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LGModal open={open} handleClose={handleClose} header="Programar Pagos">
      <Box p={2}>
        <Typography variant="body2" mb={2}>
          Se programarán todos los contrarrecibos con pagos pendientes cuya fecha de pago sea la
          seleccionada, agrupados por proveedor.
        </Typography>
        <MyDatePicker
          fullWidth
          slotProps={{ textField: { fullWidth: true } }}
          label="Fecha de pago"
          value={paymentDate}
          onChange={(value) => setPaymentDate(value)}
        />
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Stack direction="row" spacing={2}>
            <Button onClick={handleClose} variant="outlined" disabled={loading}>
              Cancelar
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              disabled={loading || !paymentDate}
            >
              {loading ? "Programando..." : "Programar"}
            </Button>
          </Stack>
        </Box>
      </Box>
    </LGModal>
  );
}
